module.exports = __webpack_public_path__ + "static/wallet-1ac81317df097da27c4f9316b2c687be.png";